import { Axios } from "./request";

const API_URL = "usersapi/v1/family/";

export const FAMILY_INFORMATION_API = {
  GetFamilyInformation: () => {
    return Axios.get(`${API_URL}GetFamilyInformation`);
  },
  AddFamilyInformation: (body) => {
    return Axios.post(`${API_URL}AddFamilyInformation`, body);
  },
  EditFamilyInformation: (body) => {
    return Axios.put(`${API_URL}EditFamilyInformation`, body);
  },
  GetFamilyInformationDetails: (profileNumber) => {
    return Axios.get(`${API_URL}GetFamilyInformationDetails?profileNumber=${profileNumber}`);
  },
  GetFamilyInformationDetailsAfterApprovalInspector: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetFamilyInformationDetailsAfterApprovalInspector?profileNumber=${profileNumber}`
    );
  },
};
